import { ENV_CONFIG } from 'config/environment';

interface AccountSetupNeededProps {
  primaryContact?: { name: string | null; email: string | null } | null;
}

const formatPrimaryContactInfo = (
  primaryContact: { name: string | null; email: string | null },
  supportEmail: string
) => {
  const { name, email } = primaryContact;

  const emailLink = email ? <a href={`mailto:${email}`}>{email}</a> : null;

  const supportLink = <a href={`mailto:${supportEmail}`}>{supportEmail}</a>;

  if (name && email) {
    return (
      <>
        Your primary contact is {name} ({emailLink}).
      </>
    );
  } else if (name) {
    return (
      <>
        Your primary contact is {name}. Please send their email address to {supportLink} so we can
        keep your account up to date.
      </>
    );
  } else if (email) {
    return <>Your primary contact&apos;s email is {emailLink}.</>;
  } else {
    return (
      <>
        Please send your primary contact&apos;s name and email address to {supportLink} so we can
        keep your account up to date.
      </>
    );
  }
};

/**
 * Dead-end screen for non-primary contacts whose onboarding form hasn't been completed.
 * "Your Account Needs to Be Set Up"
 */
export const AccountSetupNeeded = ({ primaryContact }: AccountSetupNeededProps) => {
  return (
    <div className="onboarding-form">
      <div className="onboarding-form__gradient" />
      <div className="onboarding-form__body">
        <div className="onboarding-form__header">
          <h2>Your Account Needs to Be Set Up</h2>
          <p>Please try logging back in once your primary contact has set up your account.</p>
          {primaryContact && (
            <p>{formatPrimaryContactInfo(primaryContact, ENV_CONFIG().RECIPIENTS_SUPPORT_EMAIL)}</p>
          )}
        </div>
      </div>
    </div>
  );
};
